export const SenseCaseSearch = (target, source) =>
  target.toLowerCase().includes(source.toLowerCase());
